<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <div class="text-center p-2 font-size">
            {{ $t('kyc.message.confirm.message') }}
        </div>

        <div class="text-center p-2 how-to font-size">
            {{ $t('kyc.message.confirm.description') }}
        </div>

        <table class="table text-center">
            <tbody>
                <tr>
                    <th>
                        <button type="button"  class="btn btn-primary mr-3" @click="home">{{ $t('kyc.message.confirm.home-label') }}</button>
                    </th>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'KycConfirm',

        data() {
            return {
                
            }
        },

        methods: {
            home: function(){
                this.$router.push('/');
            },
        }
    }
</script>

<style scoped>
    .how-to {
        white-space: pre-wrap;
        background-color: #fff;
        padding: 10px;
    }
    .table th, .table td {
        border-top: 0px
    }
    /*ボタンのスタイル*/
    .btn-primary:hover {
        color: #fff !important;
    }
    /*スマホ用css*/
    @media screen and (max-width: 418px) {
        .font-size{
            font-size:10px;
        }
    }
</style>